// En Home.js
import React from 'react';

function Home() {
  return <div>Inicio</div>;
}

export default Home;
